const checkEls = document.querySelectorAll('.cart-check');
const cartBtn = document.querySelector('button#checkout[form="cart"]');

// function to check if checked input els == checkbox parent els
function checkBoxes() {
  const checkedBoxes = document.querySelector('.cart__blocks')?.querySelectorAll('input[name^="attributes"]:checked');
  if (checkedBoxes && checkEls) {
    return checkEls.length === checkedBoxes.length;
  } else {
    return true;
  }
}

if (checkEls && cartBtn) {
  // if for some reason the boxes checked on browser back or whatever
  cartBtn.toggleAttribute('disabled', !checkBoxes());

  for (let i = 0; i < checkEls.length; i++) {
    const checkbox = checkEls[i].querySelector('input[type="checkbox"]');
    const errors = document.getElementById('cart-errors');
    checkbox.addEventListener('change', () => {
      cartBtn.toggleAttribute('disabled', !checkBoxes());
      if (errors?.textContent === '同意事項を確認してください') errors.textContent = '';
    });
  }

  // show error if cart button is somehow enabled and clicked but checkbox is not checked
  cartBtn.addEventListener('click', (e) => {
    const errors = document.getElementById('cart-errors');
    if (!checkBoxes()) {
      e.preventDefault();
      if (errors && !errors.textContent) errors.textContent = '同意事項を確認してください';
    }
  });
}